/**
 * Labstep
 */

import { SignatureTypeAction } from 'labstep-web/components/Signature/constants';
import { Flex } from 'labstep-web/core/Flex';
import { LabelToggle } from 'labstep-web/core/Label/Toggle';
import type React from 'react';
import { useState } from 'react';
import SignatureFormCreateSignReject from '../Form/CreateSignReject';
import type { ISignatureModalProps } from './types';

export const SignatureModal: React.FC<ISignatureModalProps> = ({
  experimentWorkflow,
  signatureTypeAction,
  toggleModal,
}) => {
  const [choice, setChoice] = useState<SignatureTypeAction>(
    signatureTypeAction,
  );

  return (
    <Flex data-testid="signature-modal" column>
      <Flex hAlignContent="center">
        <LabelToggle
          items={[
            {
              id: '1',
              icon: 'close',
              iconColor: 'red',
              text: 'Reject',
            },
            {
              id: '2',
              iconColor: 'green',
              icon: 'signup',
              text: 'Sign',
            },
          ]}
          onClick={(item) => {
            setChoice(
              item.id === '1'
                ? SignatureTypeAction.reject
                : SignatureTypeAction.sign,
            );
          }}
          activeItemId={
            choice === SignatureTypeAction.reject ? '1' : '2'
          }
        />
      </Flex>

      <SignatureFormCreateSignReject
        experimentWorkflow={experimentWorkflow}
        signatureTypeAction={choice}
        toggleModal={toggleModal}
      />
    </Flex>
  );
};
